import { Subscription } from "rxjs";

export abstract class GenericComponent {
  public _subscriptions: Subscription[] = [];
  
  set subscriptions(value: Subscription) {
    this._subscriptions.push(value);
  }
  get subscriptions(): Subscription[] {
    return this._subscriptions;
  }

  onDestroy(): void {
    this._subscriptions.map((sub) => sub.unsubscribe());
  }
}
